<script setup lang="ts">
defineProps({
  simple: { type: Boolean, default: false },
  buttonTitle: { type: String, default: 'Get exclusive content' },
  inputId: { type: String, required: true }
})

const emit = defineEmits(['hideForm'])

// ------------------------
// BACKEND
// ------------------------
// EMAIL FORM
// ------------------------

const disableButton = ref(false)
const formId = 'subscribe-form'

type SubscriberFormValues = {
  email: string
}

const subscriberFormValues = ref<SubscriberFormValues>({
  email: ''
})

const formErrors = ref<string[]>([])

// function to run if the subscription is successful
const successfulSubscription = () => {
  // enable the button
  disableButton.value = false

  // hide popup screen
  emit('hideForm')

  // Success message to user
  alert('Subscription successful! Welcome to the family!')
}

const errorSubscription = () => {
  // enable the button
  disableButton.value = false

  // show error message to console
  console.log('failed subscription')

  // Error message to user
  alert('Uh oh... something went wrong. Please try again later.')
}

const { registerMailList } = useEventReg()

async function subscriberSubmitHandler(submittedData: SubscriberFormValues) {
  // initially, set disable button to true
  disableButton.value = true

  // -------------------------------
  // BACKEND
  // -------------------------------
  // Start adding code to add email to subscribers list here
  // -------------------------------
  const email = submittedData.email
  console.log(email)

  // IF SUCCESSFUL
  try {
    await registerMailList({
      list_name: 'tl-landing-mail-list',
      email
    })
    // disable the button and then hide popup screen
    // using timeout just for illustrative purpose
    successfulSubscription()
  } catch (error) {
    console.log(error)
    errorSubscription()
  }
}

// ON UNMOUNTED
// reset the email value
onUnmounted(() => {
  subscriberFormValues.value.email = ''
})
</script>

<template>
  <div :class="`subscribe-form ${simple ? 'subscribe-form-simple' : ''}`">
    <FormKit
      :id="formId"
      v-model="subscriberFormValues"
      type="form"
      submit-label="Submit"
      :actions="false"
      :errors="formErrors"
      @submit="subscriberSubmitHandler"
    >
      <FormKit
        type="email"
        name="email"
        label=""
        placeholder="your@email.com"
        validation="required|email"
        validation-visibility="dirty"
        autocomplete="email"
      />

      <FormKit v-if="simple" :disabled="disableButton" type="submit" label="Submit"/>

      <FormKit v-else :disabled="disableButton" type="submit">
        {{ buttonTitle }}
        <CommonIconArrow />
      </FormKit>
    </FormKit>
  </div>

  <FormLoadingScreen
    :loading="disableButton"
    message="Please wait while we add your name to our list"
  />
</template>

<style scoped lang="scss">
.subscribe-form {
  form {
    display: block;
    text-align: left;

    :deep(button) {
      background-color: var(--black);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-color: var(--black);
      margin: 15px 0 0;
      min-width: 0;
      padding-left: 40px;
      padding-right: 35px;

      svg {
        $size: 14px;
        height: $size;
        width: $size;
        fill: white;
        transition:
          fill 0.3s ease-out,
          transform 0.3s ease-out;
      }
    }
  }
}

.subscribe-form-simple {
  form {
    display: grid;
    grid-template-columns: 230px auto;
    gap: 7px;
    $height: 45px;

    :deep(input) {
      border: 1px solid rgba(255, 255, 255, 0.4);
      margin: 0;
      height: $height;
      background-color: rgba(255, 255, 255, 0.1);
      color: white;
      padding-left: 25px;
    }

    :deep(button) {
      $color: var(--purple);
      margin-top: 0;
      background-color: $color;
      border-color: $color;
      color: vaR(--black);
      padding-right: 20px;
      padding-left: 20px;
      height: $height;
      font-size: 0.93rem;
    }
  }
}

@media (hover: hover) {
  form {
    :deep(button:hover) {
      background-color: transparent;
      color: var(--black);

      svg {
        fill: var(--black);
        transform: translate(5px);
      }
    }
  }

  .subscribe-form-simple {
    form {
      :deep(button:hover) {
        color: var(--purple);
      }
    }
  }
}
</style>
